import * as React from "react";
import { Path, G, ClipPath, Defs, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const UZIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="UZ" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#14DC5A"
        fillRule="evenodd"
        d="M0 8h16v4H0V8Z"
        clipRule="evenodd"
      />
      <Path
        fill="#0099B5"
        fillRule="evenodd"
        d="M0 0h16v5H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#F7FCFF"
        stroke="#C51918"
        strokeWidth={0.75}
        d="M17.375 4.625v3.75h-18.75v-3.75h18.75Z"
      />
      <Path
        fill="#F7FCFF"
        d="M1 2.569c.027-1.45 1.502-1.703 2-1.514 0 0-1.22.315-1.243 1.527-.022 1.21 1.185 1.539 1.185 1.539C2.478 4.304.973 4.018 1 2.569Zm5.606.506h.523l-.411.416.198.567-.552-.28-.49.28.14-.567-.47-.416h.613l.206-.536.243.536Zm2 0h.523l-.411.416.198.567-.552-.28-.49.28.14-.567-.47-.416h.613l.206-.536.243.536Zm2 0h.523l-.411.416.198.567-.552-.28-.49.28.14-.567-.47-.416h.613l.206-.536.243.536Zm2 0h.523l-.411.416.198.567-.552-.28-.49.28.14-.567-.47-.416h.613l.206-.536.243.536ZM4.73 3.073h.523l-.411.416.197.566-.55-.278-.492.278.14-.566-.47-.416h.614l.206-.536.243.536Zm1.847-1.318h.524l-.411.416.198.567-.552-.279-.491.279.14-.567-.47-.416h.614l.206-.536.242.536Zm2 0h.524l-.411.416.198.567-.552-.279-.491.279.14-.567-.47-.416h.614l.206-.536.242.536Zm2 0h.524l-.411.416.198.567-.552-.279-.491.279.14-.567-.47-.416h.614l.206-.536.242.536Zm2 0h.524l-.411.416.198.567-.552-.279-.491.279.14-.567-.47-.416h.614l.206-.536.242.536ZM8.605.497h.524l-.412.416.198.566-.552-.278-.49.278.14-.566-.47-.416h.613l.207-.537.242.537Zm2 0h.524l-.412.416.198.566-.552-.278-.49.278.14-.566-.47-.416h.613l.207-.537.242.537Zm2 0h.524l-.412.416.198.566-.552-.278-.49.278.14-.566-.47-.416h.613l.207-.537.242.537Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
